import { JSXElement, mergeProps, Show } from 'solid-js';
import Divider from '~/components/ui/Divider';

type RightSectionHeaderProps = {
  headerContent: JSXElement;
  subheaderContent?: JSXElement;
  hasDivider?: boolean;
  cta?: JSXElement;
  class?: string;
};

export function RightSectionHeader(props: RightSectionHeaderProps): JSXElement {
  const merged = mergeProps(
    {
      hasDivider: false,
      class: ''
    },
    props
  );

  return (
    <div class={merged.class}>
      <div class={`flex justify-end`}>
        <div class={`flex-grow`}>
          <h1 class={`text-2xl`}>{merged.headerContent}</h1>
          <Show when={merged.subheaderContent}>
            <p class={`text-fg-muted text-sm mt-1`}>
              {merged.subheaderContent}
            </p>
          </Show>
        </div>
        <Show when={merged.cta}>
          <div>{merged.cta}</div>
        </Show>
      </div>
      {/* @todo increase vertical spacing to 24px. Support variants for divider */}
      <Show when={merged.hasDivider}>
        <Divider />
      </Show>
    </div>
  );
}
